// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: '8c49d7f',
  branch: 'prod-new',
  buildDate: '2026-11-03T17:33:59.411Z',
  dirty: true,
} as const;
